import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SponsorsBanner from "../components/SponsorsBanner";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setItems(r.data.faq || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page" className="min-h-screen text-[#F5F0EB]">
      <Header />
      <section className="pt-40 pb-16 px-6 md:px-12">
        <div className="max-w-[900px] mx-auto">
          <div className="overline mb-4">{lang === "en" ? "Help" : "Aide"}</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light">{lang === "en" ? "Questions" : "Questions fréquentes"}</h1>
        </div>
      </section>
      <section className="px-6 md:px-12 pb-32">
        <div className="max-w-[900px] mx-auto divide-y divide-white/5 border-y border-white/5">
          {items.map((it, i) => {
            const q = lang === "en" ? (it.q_en || it.q_fr) : it.q_fr;
            const a = lang === "en" ? (it.a_en || it.a_fr) : it.a_fr;
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-${i}`} className="py-2">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-6 py-6 text-left group">
                  <span className="font-serif text-xl md:text-2xl group-hover:text-[#C5A059] transition-colors">{q}</span>
                  <ChevronDown size={20} className={`text-[#C5A059] flex-shrink-0 transition-transform duration-500 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div style={{ maxHeight: isOpen ? 800 : 0, opacity: isOpen ? 1 : 0 }} className="overflow-hidden transition-all duration-700 ease-out">
                  <div className="pb-6 pr-8 text-[#A8A39D] text-sm leading-7">{a}</div>
                </div>
              </div>
            );
          })}
          {!items.length && <div className="py-12 text-center text-[#A8A39D]">—</div>}
        </div>
      </section>
      <SponsorsBanner />
      <Footer />
    </div>
  );
}
